import { ComponentProps, FC } from 'react';

const ModalHeroImage: FC<Pick<ComponentProps<'img'>, 'src'>> = ({ src }) => {
  return <img alt="" className="cover w-100" src={src} />;
};
export { ModalHeroImage };
